import ky from 'ky';
import { clearToken, getJwtToken } from '@/lib/hooks/useSession';
import { getRequestLanguage } from '@/components/common/ClientProvider';
import { localeMap } from '@/lib/config/locale';
import { fallbackLng, Language } from '@/i18n/settings';

export interface ResponseMap<T> {
  data?: T;
  message: string;
  code: number;
}

export interface ResponseMap<T> {
  data?: T;
  status: string;
}
export const api = ky.extend({
  timeout: 20000,
  hooks: {
    beforeRequest: [
      (request) => {
        const session = getJwtToken();
        const language = getRequestLanguage();
        if (session) {
          request.headers.set(
            'Authorization',
            `Bearer ${session.accessToken ?? ''}`,
          );
        }
        request.headers.set('X-Language', localeMap[language]);
      },
    ],
    beforeError: [
      (error) => {
        const token = getJwtToken();
        if (error.response.status === 401 && token?.accessToken) {
          clearToken();
          window.location.reload();
        }
        return error;
      },
    ],
  },
});
export const staticDataApi = (language: Language) => {
  const locale = localeMap[language] ?? localeMap[fallbackLng];
  return ky.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set('X-Language', locale);
        },
      ],
      beforeError: [],
    },
  });
};
